module.exports = __webpack_public_path__ + "img/logo.2f426a5e.svg";